import { render, staticRenderFns } from "./StudentForm.vue?vue&type=template&id=03dbf22c&scoped=true&"
import script from "./StudentForm.vue?vue&type=script&lang=js&"
export * from "./StudentForm.vue?vue&type=script&lang=js&"
import style0 from "./StudentForm.vue?vue&type=style&index=0&id=03dbf22c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dbf22c",
  null
  
)

export default component.exports